import * as React from "react"
import { Helmet } from "react-helmet"

const Therapist = (props: React.PropsWithChildren<TherapistProps>) => {
    return (
        <section className="relative bg-yellow-50">
            <div className="absolute inset-x-0 top-0 h-96 bg-gradient-to-b from-green-100 via-green-100 to-yellow-50" />
            <div className="relative mx-auto max-w-5xl px-6 py-16 lg:px-8 lg:py-24">
                <Helmet title={`${props.name} - Therapists`} defer={false} />
                <div className="rounded-3xl bg-white p-6 shadow-lg md:p-10">
                    <div className="grid gap-8 md:grid-cols-3">
                        <div className="md:col-span-1">
                            <div className="overflow-hidden rounded-3xl shadow-lg">
                                {props.photo}
                            </div>
                        </div>
                        <div className="md:col-span-2">
                            <p className="text-sm font-bold uppercase tracking-wide text-green-900">
                                Therapist
                            </p>
                            <h1 className="mt-2 font-serif text-4xl font-bold leading-tight text-gray-900 md:text-5xl">
                                {props.name}
                            </h1>
                            {props.subtitle ? (
                                <p className="mt-3 text-lg italic text-gray-700">{props.subtitle}</p>
                            ) : null}
                            <p className="mt-3 font-semibold text-green-900">
                                {props.license}
                                {props.additionalLicense ? (
                                    <>
                                        <br />
                                        {props.additionalLicense}
                                    </>
                                ) : null}
                            </p>
                            {props.areas && props.areas.length > 0 ? (
                                <TherapistAreas areas={props.areas} />
                            ) : null}
                        </div>
                    </div>
                    <div className="mt-10 space-y-4 leading-relaxed text-gray-700">
                        {props.children}
                    </div>
                </div>
            </div>
        </section>
    )
}

const TherapistAreas = (props: { areas: string[] }) => (
    <div className="mt-6">
        <p className="text-sm font-bold uppercase tracking-wide text-gray-600">
            Areas of specialty
        </p>
        <ul className="mt-3 flex flex-wrap gap-2">
            {props.areas.map((area, i) => (
                <li
                    key={i}
                    className="rounded-full bg-green-100 px-4 py-2 text-sm font-semibold text-green-900"
                >
                    {area}
                </li>
            ))}
        </ul>
    </div>
)

export default Therapist
export interface TherapistProps {
    name: string,
    license: string,
    areas: string[],
    photo: React.ReactNode,
    additionalLicense?: string,
    subtitle?: string
}
